import { encode } from 'core/base64Utils';
import { EventLogBody } from './../dto/model';
import { API_URL, licenseKeyHeader } from 'core/constants/service';
import Rxios from 'core/services/Rxios';
import Tracking from '../../../tracking/Tracking';

class EventLogAPI extends Rxios {
  constructor() {
    super({
      baseURL: API_URL,
    });
  }

  /* Sending data to the server. */
  send = (body: EventLogBody, license: string) => {
    return this.post<void>(
      '/event-log',
      { data: encode(JSON.stringify(body)) },
      {
        headers: {
          [licenseKeyHeader]: license,
          framework: Tracking.getFrameWork(),
        },
      }
    );
  };
}

export default EventLogAPI;
